import React from 'react';

import { LayoutDefault } from '../shared/ui';
import { SignUpForm } from './sign-up-form';

function SignUp() {
  return (
    <LayoutDefault>
      <SignUpForm />
    </LayoutDefault>
  );
}

export { SignUp };
